<template>
  <div class="printer-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('printer_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-book-open-blank-variant</v-icon>{{$t('designfile.catalog')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DesignFileCatalogCard></DesignFileCatalogCard>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import ListMixin from '../../mixins/ListMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import DesignFileCatalogCard from '../../components/designfile/catalog.vue'

export default {
  name: 'DesignFileCatalog',
  servicePrefix: 'DesignFile',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    DesignFileCatalogCard,

  },

};
</script>
